import "../styles/reset.scss"
import "../styles/globals.scss"

import CookieProvider from "@components/Contexts/CookieContext"
import {HeaderProvider} from "@components/Contexts/HeaderContext"
import LayoutProvider from "@components/Contexts/LayoutContext"
import {LocaleProvider} from "@components/Contexts/LocaleContext"
import {MetaDataProvide} from "@components/Contexts/MetaDataContext"
import Layout from "@components/Theme/Layout/Layout"
import stripProductLinkTracking from "@helpers/stripProductLinkTracking"
import Cookies from "js-cookie"
import type {AppProps} from "next/app"
import Script from "next/script"
import React, {useEffect, useState} from "react"

export default function App({
	Component,
	pageProps,
	router,
}: AppProps): JSX.Element {
	const GTM_ID = process.env.NEXT_PUBLIC_GTM_ID

	const [gtmEnabled, setGtmEnabled] = useState(false)

	useEffect(() => {
		if (Cookies.get("thirdPartyCookies") === "1") {
			setGtmEnabled(true)
		}
	}, [])

	useEffect(() => {
		// Bubble phase runs after the Google tag adds _gl during capture.
		document.addEventListener("click", stripProductLinkTracking)
		return () => {
			document.removeEventListener("click", stripProductLinkTracking)
		}
	}, [])

	return (
		<>
			{/* Google Tag Manager (head) - only load when user has given marketing/analytics consent */}
			{gtmEnabled && (
				<Script id={"gtm"} strategy={"afterInteractive"}>
					{`
					(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
					new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
					j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
					'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
					})(window,document,'script','dataLayer','${GTM_ID}');
					`}
				</Script>
			)}
			<LocaleProvider>
				<MetaDataProvide>
					<CookieProvider>
						<HeaderProvider>
							<LayoutProvider>
								<div className={"App"} />
								{/* <HeadMeta /> */}
								<Layout
									Component={Component}
									pageProps={pageProps}
									router={router}
								/>
							</LayoutProvider>
						</HeaderProvider>
					</CookieProvider>
				</MetaDataProvide>
			</LocaleProvider>
		</>
	)
}
